const {createContext} = require("react");

const SignContext =  createContext();

export default SignContext;